module.exports = __webpack_public_path__ + "static/media/navidad2.54731d74.webp";